<template>
  <ORow right style="width: auto">
    <div class="px-4 caption">
      <span class="hidden-sm-and-down" v-if="!dense">Mostrando</span>
      {{ firstIndexShown }} ─ {{ lastIndexShown }}
      <span v-if="count != null">de {{ count }}</span>
    </div>

    <div>
      <v-btn icon :small="dense" :disabled="offset < 1" @click="navigate(-1)">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-btn icon :small="dense" :disabled="!hasMore" @click="navigate(+1)">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </div>
  </ORow>
</template>

<script>
export default {
  props: {
    offset: {},
    count: {},
    limit: {},
    dense: { type: Boolean, default: false }
  },
  computed: {
    firstIndexShown() {
      return this.offset + 1
    },
    lastIndexShown() {
      if (this.count == null) return this.nextOffset
      else return Math.min(this.nextOffset, this.count)
    },
    nextOffset() {
      return this.offset + this.limit
    },
    hasMore() {
      if (this.count == null) return true
      else return this.nextOffset <= this.count
    }
  },
  methods: {
    navigate(x) {
      let offset = this.offset + x * this.limit
      this.$emit('update:offset', offset)
    }
  }
}
</script>

<style></style>
